import { render, staticRenderFns } from "./homeSU.vue?vue&type=template&id=e67be2b0&"
import script from "./homeSU.vue?vue&type=script&lang=js&"
export * from "./homeSU.vue?vue&type=script&lang=js&"
import style0 from "./homeSU.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports